module.exports = __webpack_public_path__ + "static/img/34优舍.a44919f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/34优舍.jpg
// module id = ptjM
// module chunks = 1